import axios from "axios";

export default {
    methods: {
        async getFolderOptions(client_id) {
            let options = {};
            let response = await axios.get('/api/client/' + client_id + '/folder');
            if (response && response.status === 200) {
                const buildOptions = (folders, depth = 0) => {
                    folders.forEach(folder => {
                        // Indent with hyphens based on depth
                        const prefix = depth > 0 ? '---'.repeat(depth) : '';
                        options[folder.folder_id] = prefix + folder.folder_name;
                        if (folder.children && folder.children.length > 0) {
                            buildOptions(folder.children, depth + 1);
                        }
                    });
                };
                buildOptions(response.data);
            }
            return options;
        }
    }
};